<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=550 content-class="round-2xl")
  v-card
    div.py-6.px-10
      .text-md Are you sure to change the status to "Archived"?
    v-divider
    v-card-actions.px-6
      v-spacer
      v-btn.button-md.neutral700--text.px-0.underline(text @click="closeDialog") {{ $t('cancel') }}
      v-btn.button-md(:loading="isLoading" color="danger500" depressed dark @click="handleConfirm") {{ $t('confirm') }}
</template>
  
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
    },
    parentId: {
      type: Number,
      default: null
    },
    selectedDocument: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    closeDialog() {
      this.$emit('closed')
      this.showDialog = false
    },
    getEndpoint () {
      const baseEndpoint = `/purchases/${this.company.slug}`
      switch (this.selectedDocument.id) {
        case 'quotation':
          return `${baseEndpoint}/quotations`

        case 'purchase-order':
          return `${baseEndpoint}/orders`

        case 'invoice':
          return `${baseEndpoint}/invoices`
      
        default:
          return ''
      }
    },
    async handleConfirm () {
      try {
        this.isLoading = true
        const endpoint = `${this.getEndpoint()}/${this.parentId}`
        const payload = this.selectedDocument.id === 'quotation' ? { request_status: 'archived' } : { order_status: 'archived' }
        await this.axios.patch(endpoint, payload)
        this.$emit('updated')
        this.updateActivityLog(endpoint, payload, null, 'PATCH', this.parentId)
        this.showMessage(['success', 'Status changed to archived successfully'])
        this.closeDialog()
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    },
    updateActivityLog (endpoint, payload, response, method, id) {
      let data = {
        company: this.company.id,
        object_id: id,
        object_ref: null,
        activity: `${this.selectedDocument.id} archived`,
        raw_data: { endpoint, payload, response, method }
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    },
  },
}
</script>

<style scoped>
</style>